import $ from 'jquery';

export default class ListPreviewController {
	/** @type {any} */
	#oldListWidth;

	/* @ngInject */
	/**
	 * @param {Knitiv.RootScope} $rootScope
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} User
	 */
	constructor($rootScope, $scope, $timeout, User) {
		this.$rootScope = $rootScope;
		this.$scope = $scope;
		this.$timeout = $timeout;
		this.User = User;
		this.#oldListWidth = null;

		/** @type {any} */
		this.formOptions = {
			mode:       'normal',
			new_isa:    null,
			parent:     null,
			readOnly:   true,
			tab:        'form',
			fullScreen: () => this.fullScreen(),
			viewMode:   1,
		};

		/** @type {boolean} */
		this.fullScreenMode = false;

		/** @type {boolean} */
		this.isAdmin = false;

		/** @type {any} */
		this.row = undefined;

		/** @type {any} */
		this.obj = {
			item: null,
			node: null,
		};

		/** @type {string | undefined} */
		this.tab = undefined;
	}

	cancel() {
		this.formOptions.readOnly = true;
	}

	fullScreen() {
		const $knList = $('.kn-list');
		if (this.fullScreenMode) {
			this.fullScreenMode = false;
			this.$rootScope.showSearch = true;
			$knList.css('flex-basis', this.#oldListWidth);
		}
		else {
			this.fullScreenMode = true;
			this.$rootScope.showSearch = false;
			this.#oldListWidth = $knList.css('flex-basis');
			$knList.css('flex-basis', 0);
		}
	}

	/**
	 * @param {import('angular').IOnChangesObject} changes
	 */
	$onChanges(changes) {
		if (changes.tab) {
			this.formOptions.tab = this.tab;
		}
		if (changes.row) {
			this.formOptions.new_isa = this.row?.getData().new_isa;
		}
	}

	$onInit() {
		this.isAdmin = this.User?.getProfil()?.admin;

		this.formOptions.tab = this.tab;

		this.$scope.$on('list-header-resize', () => {
			const width = $('.kn-list').css('flex-basis');
			if (this.#oldListWidth === null) {
				this.#oldListWidth = width;
			}
			this.fullScreenMode = Number.parseInt(width, 10) === 0;
		});
	}
}
